import axios from 'axios'
import config from '../config'

type TokenProvider = () => Promise<string>

let getToken: TokenProvider | null = null

// Set by the auth context once the user is signed in. Kept on this module
// rather than on the global axios instance so the API token is never attached
// to requests aimed at other hosts — blob-storage talks straight to Azure
// Storage, which authenticates with a SAS and must never see an AAD token.
export const setApiTokenProvider = (provider: TokenProvider | null) => {
  getToken = provider
}

const apiClient = axios.create({baseURL: config.apiUrl})

apiClient.interceptors.request.use(async request => {
  if (!getToken) return request

  const accessToken = await getToken()
  if (!accessToken) return request

  return {
    ...request,
    headers: {...request.headers, Authorization: `Bearer ${accessToken}`}
  }
})

export default apiClient
